import './styles/global.css';
import React, { lazy, Suspense } from 'react';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import { ToastProvider } from './components/ui/Toast';

// Eager load — her zaman hemen lazım
import Home  from './pages/Home';
import Login from './pages/Auth';

// Lazy load — ilgili sayfaya gidilince yüklenir
const Portfolio   = lazy(() => import('./pages/Portfolio'));
const ItemDetail  = lazy(() => import('./pages/Portfolio/itemDetail'));
const NewItem     = lazy(() => import('./pages/Portfolio/newItem'));
const About       = lazy(() => import('./pages/About'));
const Journey     = lazy(() => import('./pages/Journey'));
const Learning    = lazy(() => import('./pages/Learning'));
const AITools     = lazy(() => import('./pages/AITools'));
const Cheatsheets = lazy(() => import('./pages/Cheatsheets'));

function PageLoader() {
  return (
    <div className="container section" style={{ textAlign: 'center', minHeight: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <p style={{ color: 'var(--text-secondary)' }}>Yükleniyor...</p>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <ToastProvider>
          <div className="App">
            <Router>
              <Header />
              <Suspense fallback={<PageLoader />}>
                <Routes>
                  <Route path="/"                     element={<Home />} />
                  <Route path="/portfolio"            element={<Portfolio />} />
                  <Route path="/portfolio/:articleId" element={<ItemDetail />} />
                  <Route path="/about"                element={<About />} />
                  <Route path="/login"                element={<Login />} />
                  <Route path="/journey"              element={<Journey />} />
                  <Route path="/learning"             element={<Learning />} />
                  <Route path="/learning/:pathId"     element={<Learning />} />
                  <Route path="/ai-tools"             element={<AITools />} />
                  <Route path="/ai-tools/:toolId"     element={<AITools />} />
                  <Route path="/cheatsheets"          element={<Cheatsheets />} />
                  <Route path="/cheatsheets/:toolId"  element={<Cheatsheets />} />
                  <Route
                    path="/admin/new-article"
                    element={
                      <ProtectedRoute>
                        <NewItem />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </Suspense>
              <Footer />
            </Router>
          </div>
          </ToastProvider>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
